import React from 'react';

import {
  useGroupUserInvitationsState,
  useGroupUserInvitationsActions
} from './GroupUserInvitationsContext';

import {
  generateAndSendGroupUserInvitation,
} from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormRow from '../../Shared/UI/FormRow/components/FormRow';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import Button from '../../Shared/UI/Button/components/Button';

const NewGroupUserInvitationForm = () => {
  const groupUserInvitationsState = useGroupUserInvitationsState();
  const { onResponse, onError, updateFirstName, updateLastName, updateEmail } = useGroupUserInvitationsActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const groupId = groupUserInvitationsState?.groupId;

  const handleSubmit = () => {
    generateAndSendGroupUserInvitation({
      groupId,
      onResponse,
      onError,
      body: {
        newOpenUserInvitation: {
          firstName: groupUserInvitationsState?.newOpenUserInvitation?.firstName,
          lastName: groupUserInvitationsState?.newOpenUserInvitation?.lastName,
          email: groupUserInvitationsState?.newOpenUserInvitation?.email,
          groupId: groupId,
        },
        authenticityToken: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormRow>
        <Field label="First Name" id="firstName">
          <Input
            type="text"
            value={groupUserInvitationsState?.newOpenUserInvitation?.firstName || ''}
            onChange={(e) => updateFirstName(e.target.value)}
          />
        </Field>

        <Field label="Last Name" id="lastName">
          <Input
            type="text"
            value={groupUserInvitationsState?.newOpenUserInvitation?.lastName || ''}
            onChange={(e) => updateLastName(e.target.value)}
          />
        </Field>
      </FormRow>

      <Field label="Email" id="email">
        <Input
          type="email"
          value={groupUserInvitationsState?.newOpenUserInvitation?.email || ''}
          onChange={(e) => updateEmail(e.target.value)}
        />
      </Field>

      <Button type="submit">
        Generate and send invitation
      </Button>
    </Form>
  );
};

export default NewGroupUserInvitationForm;
